
Object.defineProperty(exports, "__esModule", { value: true });

const {
  Decimal,
  objectEnumValues,
  makeStrictEnum,
  Public,
  detectRuntime,
} = require('@prisma/client/runtime/index-browser')


const Prisma = {}

exports.Prisma = Prisma
exports.$Enums = {}

/**
 * Prisma Client JS version: 5.6.0
 * Query Engine version: e95e739751f42d8ca026f6b910f5a2dc5adeaeee
 */
Prisma.prismaVersion = {
  client: "5.6.0",
  engine: "e95e739751f42d8ca026f6b910f5a2dc5adeaeee"
}

Prisma.PrismaClientKnownRequestError = () => {
  throw new Error(`PrismaClientKnownRequestError is unable to be run ${runtimeDescription}.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)};
Prisma.PrismaClientUnknownRequestError = () => {
  throw new Error(`PrismaClientUnknownRequestError is unable to be run ${runtimeDescription}.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.PrismaClientRustPanicError = () => {
  throw new Error(`PrismaClientRustPanicError is unable to be run ${runtimeDescription}.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.PrismaClientInitializationError = () => {
  throw new Error(`PrismaClientInitializationError is unable to be run ${runtimeDescription}.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.PrismaClientValidationError = () => {
  throw new Error(`PrismaClientValidationError is unable to be run ${runtimeDescription}.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.NotFoundError = () => {
  throw new Error(`NotFoundError is unable to be run ${runtimeDescription}.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.Decimal = Decimal

/**
 * Re-export of sql-template-tag
 */
Prisma.sql = () => {
  throw new Error(`sqltag is unable to be run ${runtimeDescription}.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.empty = () => {
  throw new Error(`empty is unable to be run ${runtimeDescription}.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.join = () => {
  throw new Error(`join is unable to be run ${runtimeDescription}.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.raw = () => {
  throw new Error(`raw is unable to be run ${runtimeDescription}.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.validator = Public.validator

/**
* Extensions
*/
Prisma.getExtensionContext = () => {
  throw new Error(`Extensions.getExtensionContext is unable to be run ${runtimeDescription}.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.defineExtension = () => {
  throw new Error(`Extensions.defineExtension is unable to be run ${runtimeDescription}.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}

/**
 * Shorthand utilities for JSON filtering
 */
Prisma.DbNull = objectEnumValues.instances.DbNull
Prisma.JsonNull = objectEnumValues.instances.JsonNull
Prisma.AnyNull = objectEnumValues.instances.AnyNull

Prisma.NullTypes = {
  DbNull: objectEnumValues.classes.DbNull,
  JsonNull: objectEnumValues.classes.JsonNull,
  AnyNull: objectEnumValues.classes.AnyNull
}

/**
 * Enums
 */

exports.Prisma.TransactionIsolationLevel = makeStrictEnum({
  ReadUncommitted: 'ReadUncommitted',
  ReadCommitted: 'ReadCommitted',
  RepeatableRead: 'RepeatableRead',
  Serializable: 'Serializable'
});

exports.Prisma.TokenScalarFieldEnum = {
  id: 'id',
  address: 'address',
  chainId: 'chainId',
  name: 'name',
  symbol: 'symbol',
  decimals: 'decimals',
  status: 'status',
  isFeeOnTransfer: 'isFeeOnTransfer',
  isCommon: 'isCommon',
  derivedUSD: 'derivedUSD',
  derivedNative: 'derivedNative',
  generatedAt: 'generatedAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.PoolScalarFieldEnum = {
  id: 'id',
  address: 'address',
  name: 'name',
  chainId: 'chainId',
  protocol: 'protocol',
  version: 'version',
  type: 'type',
  isWhitelisted: 'isWhitelisted',
  token0Id: 'token0Id',
  token1Id: 'token1Id',
  swapFee: 'swapFee',
  twapEnabled: 'twapEnabled',
  reserve0: 'reserve0',
  reserve1: 'reserve1',
  liquidityUSD: 'liquidityUSD',
  generatedAt: 'generatedAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.SushiPoolScalarFieldEnum = {
  id: 'id',
  address: 'address',
  name: 'name',
  chainId: 'chainId',
  protocol: 'protocol',
  token0Id: 'token0Id',
  token1Id: 'token1Id',
  swapFee: 'swapFee',
  twapEnabled: 'twapEnabled',
  reserve0: 'reserve0',
  reserve1: 'reserve1',
  totalSupply: 'totalSupply',
  liquidityUSD: 'liquidityUSD',
  liquidityNative: 'liquidityNative',
  volumeUSD: 'volumeUSD',
  feesUSD: 'feesUSD',
  volumeNative: 'volumeNative',
  token0Price: 'token0Price',
  token1Price: 'token1Price',
  liquidityUSDChange1h: 'liquidityUSDChange1h',
  liquidityUSDChange1d: 'liquidityUSDChange1d',
  liquidityUSDChange1w: 'liquidityUSDChange1w',
  liquidityUSDChange1m: 'liquidityUSDChange1m',
  volume1h: 'volume1h',
  volume1d: 'volume1d',
  volume1w: 'volume1w',
  volume1m: 'volume1m',
  volumeChange1h: 'volumeChange1h',
  volumeChange1d: 'volumeChange1d',
  volumeChange1w: 'volumeChange1w',
  volumeChange1m: 'volumeChange1m',
  fees1h: 'fees1h',
  fees1d: 'fees1d',
  fees1w: 'fees1w',
  fees1m: 'fees1m',
  feesChange1h: 'feesChange1h',
  feesChange1d: 'feesChange1d',
  feesChange1w: 'feesChange1w',
  feesChange1m: 'feesChange1m',
  feeApr1h: 'feeApr1h',
  feeApr1d: 'feeApr1d',
  feeApr1w: 'feeApr1w',
  feeApr1m: 'feeApr1m',
  totalApr1h: 'totalApr1h',
  totalApr1d: 'totalApr1d',
  totalApr1w: 'totalApr1w',
  totalApr1m: 'totalApr1m',
  incentiveApr: 'incentiveApr',
  isIncentivized: 'isIncentivized',
  wasIncentivized: 'wasIncentivized',
  hasEnabledSteerVault: 'hasEnabledSteerVault',
  hadEnabledSteerVault: 'hadEnabledSteerVault',
  createdAtBlockNumber: 'createdAtBlockNumber',
  isBlacklisted: 'isBlacklisted',
  generatedAt: 'generatedAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.IncentiveScalarFieldEnum = {
  id: 'id',
  chainId: 'chainId',
  chefType: 'chefType',
  apr: 'apr',
  rewardPerDay: 'rewardPerDay',
  rewardTokenId: 'rewardTokenId',
  poolId: 'poolId',
  pid: 'pid',
  rewarderAddress: 'rewarderAddress',
  rewarderType: 'rewarderType'
};

exports.Prisma.SteerVaultScalarFieldEnum = {
  id: 'id',
  address: 'address',
  chainId: 'chainId',
  poolId: 'poolId',
  feeTier: 'feeTier',
  apr: 'apr',
  apr1w: 'apr1w',
  apr1d: 'apr1d',
  apr1m: 'apr1m',
  apr1y: 'apr1y',
  token0Id: 'token0Id',
  reserve0: 'reserve0',
  reserve0USD: 'reserve0USD',
  fees0: 'fees0',
  fees0USD: 'fees0USD',
  token1Id: 'token1Id',
  reserve1: 'reserve1',
  reserve1USD: 'reserve1USD',
  fees1: 'fees1',
  fees1USD: 'fees1USD',
  reserveUSD: 'reserveUSD',
  feesUSD: 'feesUSD',
  strategy: 'strategy',
  payloadHash: 'payloadHash',
  description: 'description',
  state: 'state',
  performanceFee: 'performanceFee',
  lowerTick: 'lowerTick',
  upperTick: 'upperTick',
  adjustmentFrequency: 'adjustmentFrequency',
  lastAdjustmentTimestamp: 'lastAdjustmentTimestamp',
  isEnabled: 'isEnabled',
  wasEnabled: 'wasEnabled',
  isDeprecated: 'isDeprecated',
  creator: 'creator',
  admin: 'admin',
  manager: 'manager',
  generatedAt: 'generatedAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.BondMarketScalarFieldEnum = {
  id: 'id',
  description: 'description'
};

exports.Prisma.BondIssuerIdScalarFieldEnum = {
  id: 'id',
  bondIssuerName: 'bondIssuerName'
};

exports.Prisma.BondIssuerScalarFieldEnum = {
  name: 'name',
  link: 'link',
  isApproved: 'isApproved'
};

exports.Prisma.SortOrder = {
  asc: 'asc',
  desc: 'desc'
};

exports.Prisma.NullsOrder = {
  first: 'first',
  last: 'last'
};
exports.TokenStatus = exports.$Enums.TokenStatus = {
  APPROVED: 'APPROVED',
  UNKNOWN: 'UNKNOWN',
  DISAPPROVED: 'DISAPPROVED'
};

exports.Protocol = exports.$Enums.Protocol = {
  SUSHISWAP_V2: 'SUSHISWAP_V2',
  SUSHISWAP_V3: 'SUSHISWAP_V3',
  BENTOBOX_STABLE: 'BENTOBOX_STABLE',
  BENTOBOX_CLASSIC: 'BENTOBOX_CLASSIC'
};

exports.ChefType = exports.$Enums.ChefType = {
  MasterChefV1: 'MasterChefV1',
  MasterChefV2: 'MasterChefV2',
  MiniChef: 'MiniChef',
  Merkl: 'Merkl'
};

exports.RewarderType = exports.$Enums.RewarderType = {
  Primary: 'Primary',
  Secondary: 'Secondary'
};

exports.SteerStrategy = exports.$Enums.SteerStrategy = {
  SuperWide: 'SuperWide',
  DeltaNeutralStables: 'DeltaNeutralStables',
  StableExpansion: 'StableExpansion',
  ElasticExpansion: 'ElasticExpansion',
  MovingVolatilityChannel: 'MovingVolatilityChannel',
  MovingVolatilityChannelMedium: 'MovingVolatilityChannelMedium',
  HighLowChannel: 'HighLowChannel',
  StaticStable: 'StaticStable',
  ClassicRebalance: 'ClassicRebalance',
  ChannelMultiplier: 'ChannelMultiplier',
  PriceMultiplier: 'PriceMultiplier',
  FixedPercentage: 'FixedPercentage',
  KeltnerAlgo: 'KeltnerAlgo',
  BollingerAlgo: 'BollingerAlgo'
};

exports.VaultState = exports.$Enums.VaultState = {
  PendingApproval: 'PendingApproval',
  PendingThreshold: 'PendingThreshold',
  Paused: 'Paused',
  Active: 'Active',
  Retired: 'Retired'
};

exports.Prisma.ModelName = {
  Token: 'Token',
  Pool: 'Pool',
  SushiPool: 'SushiPool',
  Incentive: 'Incentive',
  SteerVault: 'SteerVault',
  BondMarket: 'BondMarket',
  BondIssuerId: 'BondIssuerId',
  BondIssuer: 'BondIssuer'
};

/**
 * This is a stub Prisma Client that will error at runtime if called.
 */
class PrismaClient {
  constructor() {
    return new Proxy(this, {
      get(target, prop) {
        const runtime = detectRuntime()
        const edgeRuntimeName = {
          'workerd': 'Cloudflare Workers',
          'deno': 'Deno and Deno Deploy',
          'netlify': 'Netlify Edge Functions',
          'edge-light': 'Vercel Edge Functions',
        }[runtime]

        let message = 'PrismaClient is unable to run in '
        if (edgeRuntimeName !== undefined) {
          message += edgeRuntimeName + '. As an alternative, try Accelerate: https://pris.ly/d/accelerate.'
        } else {
          message += 'this browser environment, or has been bundled for the browser (running in `' + runtime + '`).'
        }
        
        message += `
If this is unexpected, please open an issue: https://github.com/prisma/prisma/issues`

        throw new Error(message)
      }
    })
  }
}

exports.PrismaClient = PrismaClient

Object.assign(exports, Prisma)
